import { forwardRef, useCallback } from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconFilledProps, IconRender } from '../types.ts';

const TemporaryUnavailable = forwardRef<SVGSVGElement | null, IconFilledProps>(function TemporaryUnavailable(
  { filled, dataTestId, ...props },
  ref,
) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          d='M7.5891 15.4731L9.39476 13.6924H9.23947C8.78037 13.6924 8.35792 13.4782 8.13735 13.1336C7.91678 12.789 7.93259 12.3687 8.17902 12.037L12.5085 6.21378C12.645 6.0304 12.9115 5.95286 13.1508 6.02916C13.3886 6.10486 13.5323 6.31224 13.4963 6.52762L12.8921 10.1325C12.8862 10.1713 12.8969 10.2024 12.9106 10.2251L15.763 7.4121C15.8818 7.29495 16.0744 7.29495 16.1932 7.4121L16.4083 7.62424C16.5271 7.74139 16.5271 7.93134 16.4083 8.0485L8.2344 16.1095C8.11561 16.2267 7.923 16.2267 7.8042 16.1095L7.5891 15.8974C7.4703 15.7802 7.4703 15.5903 7.5891 15.4731Z'
          fill={filled ? 'transparent' : color}
        />
        <path
          d='M15.2429 10.3085C15.7013 10.3085 16.1238 10.5226 16.345 10.8672C16.5656 11.2118 16.5498 11.6315 16.3034 11.9632L11.9768 17.7865C11.8755 17.9225 11.7016 18 11.522 18C11.4595 18 11.3963 17.9908 11.3352 17.9717C11.0974 17.896 10.953 17.6886 10.9889 17.4732L11.5903 13.8684L11.593 13.8509C11.5996 13.8078 11.6066 13.7625 11.6372 13.7323L15.0199 10.3963C15.0769 10.3401 15.1543 10.3085 15.235 10.3085H15.2429Z'
          fill={filled ? 'transparent' : color}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5Z'
          fill={filled ? 'transparent' : color}
        />
        {/* filled */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM7.5891 15.4731L9.39476 13.6924H9.23947C8.78037 13.6924 8.35792 13.4782 8.13735 13.1336C7.91678 12.789 7.93259 12.3687 8.17902 12.037L12.5085 6.21378C12.645 6.0304 12.9115 5.95286 13.1508 6.02916C13.3886 6.10486 13.5323 6.31224 13.4963 6.52762L12.8921 10.1325C12.8862 10.1713 12.8969 10.2024 12.9106 10.2251L15.763 7.4121C15.8818 7.29495 16.0744 7.29495 16.1932 7.4121L16.4083 7.62424C16.5271 7.74139 16.5271 7.93134 16.4083 8.0485L8.2344 16.1095C8.11561 16.2267 7.923 16.2267 7.8042 16.1095L7.5891 15.8974C7.4703 15.7802 7.4703 15.5903 7.5891 15.4731ZM15.2429 10.3085C15.7013 10.3085 16.1238 10.5226 16.345 10.8672C16.5656 11.2118 16.5498 11.6315 16.3034 11.9632L11.9768 17.7865C11.8755 17.9225 11.7016 18 11.522 18C11.4595 18 11.3963 17.9908 11.3352 17.9717C11.0974 17.896 10.953 17.6886 10.9889 17.4732L11.5903 13.8684L11.593 13.8509C11.5996 13.8078 11.6066 13.7625 11.6372 13.7323L15.0199 10.3963C15.0769 10.3401 15.1543 10.3085 15.235 10.3085H15.2429Z'
          fill={filled ? color : 'transparent'}
        />
      </>
    ),
    [filled],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'temporary-unavailable-icon-svg'} iconRender={iconRender} {...props} />;
});

export default TemporaryUnavailable;
